import React from 'react';
import { CallAnalysisDashboard } from './components/CallAnalysisDashboard';
export function App() {
  return <CallAnalysisDashboard data-id="element-0" />;
}